import { Component } from 'react'
import Autocomplete from 'react-google-autocomplete'
import { removeSubstringAfterCharacter } from 'utils/helpers'

const style = {
  width: '100%',
  height: '40px',
  paddingLeft: '8px',
  paddingRight: '8px'
}

class GoogleAutocomplete extends Component {
  getCityorZipCode = (addressArray = [], type) => {
    let value = ''
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0] && addressArray[i].types[0] === type) {
        value = addressArray[i].long_name
        return value
      }
    }
  }

  getProperty = (addressArray = [], type, property) => {
    let value = ''
    for (let i = 0; i < addressArray.length; i++) {
      for (let i = 0; i < addressArray.length; i++) {
        if (addressArray[i].types[0] && addressArray[i].types[0] === property) {
          value = addressArray[i][type]
          return value
        }
      }
    }
  }

  onPlaceSelected = place => {
    const { formatted_address, address_components, geometry } = place
    const address = formatted_address ? removeSubstringAfterCharacter(formatted_address, ',') : ''
    const addressArray = address_components
    const city = this.getCityorZipCode(addressArray, 'locality')
    const state = this.getProperty(addressArray, 'long_name', 'administrative_area_level_1')
    const shortState = this.getProperty(addressArray, 'short_name', 'administrative_area_level_1')
    const latitude = geometry.location.lat()
    const longitude = geometry.location.lng()
    const zipCode = this.getCityorZipCode(addressArray, 'postal_code')
    const country = this.getProperty(addressArray, 'long_name', 'country')
    const streetNumber = this.getProperty(addressArray, 'long_name', 'street_number')
    const street = `${streetNumber || ''} ${
      this.getProperty(addressArray, 'long_name', 'route') || ''
    }`.trim()
    this.props.onSelectCallback?.({
      address,
      city: city || '',
      state,
      shortState,
      latitude,
      longitude,
      zipCode,
      country,
      street
    })
  }

  render() {
    const { value, onChange, className, onBlur, cy, tabIndex } = this.props
    return (
      <Autocomplete
        value={value}
        style={style}
        onChange={e => onChange(e.target.value)}
        className={className}
        onPlaceSelected={this.onPlaceSelected}
        options={{
          types: ['geocode']
          // componentRestrictions: { country: 'us' }
        }}
        onBlur={onBlur}
        data-cy={cy}
        tabIndex={tabIndex}
      />
    )
  }
}

export default GoogleAutocomplete
